import { render } from "./OnboardingHeader.vue?vue&type=template&id=b1d7bf66"
import script from "./OnboardingHeader.vue?vue&type=script&lang=js"
export * from "./OnboardingHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__